import { useLocation } from 'react-router-dom';

import { QUERY_PARAMS } from '@/constants';

export const useGetTBKToken = (): string | null => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const tokenWs = queryParams.get(QUERY_PARAMS.TOKEN_WS);
  const tbkToken = queryParams.get(QUERY_PARAMS.TBK_TOKEN);
  return tokenWs ?? tbkToken;
};
